import { Icon } from '@livable/saas-react-components';
import { Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React from 'react';
import useStyles from './styles';
export default function ListStatusHeader(props) {
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const status = props.status,
    icon = props.icon,
    title = props.title,
    additionalTitle = props.additionalTitle,
    enableEdit = props.enableEdit,
    editModeIsOn = props.editModeIsOn,
    handleEditClick = props.handleEditClick,
    handleSubmit = props.handleSubmit,
    type = props.type,
    _props$isDisabledSave = props.isDisabledSave,
    isDisabledSave = _props$isDisabledSave === void 0 ? false : _props$isDisabledSave,
    children = props.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.listHeader, " ").concat(classes[status])
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, icon && /*#__PURE__*/React.createElement("span", {
    className: classes.iconWrapper
  }, icon), /*#__PURE__*/React.createElement("div", null, type === 'middle' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, title), additionalTitle && /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, additionalTitle)), type !== 'middle' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, title), additionalTitle && /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "light"
  }, additionalTitle)))), children && children, enableEdit && /*#__PURE__*/React.createElement(React.Fragment, null, !editModeIsOn && /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    onClick: () => handleEditClick(true),
    'custom-attribute': '58-list-status-header'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  })), editModeIsOn && /*#__PURE__*/React.createElement("div", {
    className: classes.actionButtons
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    size: "small",
    onClick: () => handleEditClick(false),
    'custom-attribute': '59-list-status-header'
  }, t('buttons.cancel')), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    disabled: isDisabledSave,
    onClick: () => {
      handleSubmit();
      handleEditClick(false);
    },
    'custom-attribute': '60-list-status-header'
  }, t('buttons.save')))));
}